export default __webpack_public_path__ + "static/media/non-trad.10444c5e.svg";